import request from "../utils/request.js"

// 获取商品列表
export function getIntentionListApi(params) {
    return request({
        url: "/intention/list",
        method: "post",
        data: params,
    })
}
// 新增意向单
export function saveIntentionApi(params) {
    return request({
        url: "/intention/saveIntention",
        method: "post",
        data: params,
    })
}

